import CopyAllIcon from "@mui/icons-material/CopyAll";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function CopyButton({ value, sx = {}, icon_sx }) {
	const { t } = useTranslation();
	const [showTooltip, setShowTooltip] = useState(false);

	const handleCopy = async () => {
		if ("clipboard" in navigator) {
			await navigator.clipboard.writeText(value);
		} else {
			document.execCommand("copy", true, value);
		}

		setShowTooltip(true);

		setTimeout(() => {
			setShowTooltip(false);
		}, 2000);
	};

	return (
		<Tooltip title={t("buttons.copied")} open={showTooltip}>
			<IconButton onClick={handleCopy} size="small" sx={{ ml: 0.5, ...sx }}>
				<CopyAllIcon sx={{ ...icon_sx }} />
			</IconButton>
		</Tooltip>
	);
}
